import { Component, computed, input } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { TranslateTokenPipe } from "../../../../../../../../core/pipes/translate-token-pipe";
import type { ReadingOperationStrategicTaskRevision } from "../../../../../../../models/operation-strategic-task-model";
import { diffAikpiItems, haveAikpiItemsChanged } from "./aikpi-items-diff";

@Component({
  selector: "adaa-aikpi-items-view",
  imports: [TranslatePipe, TranslateTokenPipe],
  templateUrl: "./aikpi-items-view.html",
  styleUrl: "../styles.scss",
})
export class AikpiItemsViewComponent {
  readonly title = input<string>("");
  readonly newItems = input<ReadingOperationStrategicTaskRevision[]>([]);
  readonly oldItems = input<ReadingOperationStrategicTaskRevision[]>([]);

  readonly columns = computed(() => {
    const newItems = this.newItems();
    const oldItems = this.oldItems();
    if (!haveAikpiItemsChanged(newItems, oldItems)) {
      return [{ side: "unchanged", label: "", rows: diffAikpiItems(newItems, oldItems) }];
    }

    return [
      { side: "new", label: "communication.difference.new_value", rows: diffAikpiItems(newItems, oldItems) },
      { side: "old", label: "communication.difference.old_value", rows: diffAikpiItems(oldItems, newItems) },
    ];
  });
}
